export default "__VITE_ASSET__CytIsRLt__"